<template>
  <div class="navbar clearfix">
    <div class="navbar-left">
      <a href="javascript:void(0)" class="sidebar-trigger">
      </a>
      <a v-if="currentPagePath == '/supervise/detail'" class="close-left" @click="closeLeft">
        <i class="icon-fold-open"></i>
      </a>
      <a v-else class="close-left"></a>
      <ul class="navbar-menu">
        <li class="menu-title">
          <a :class="[activeMenu == 'studentList' ? 'active' : '']"  @click="gotoIndex">{{isAgent ? `${$t('layout.Navbar.494044-0')}` : `${$t('layout.Navbar.494044-1')}`}}</a>
          <!-- <a class="back-index" v-if="isShowBack" @click="gotoIndex">
            <i class="el-icon-arrow-left"></i>
            返回概览首页
          </a> -->
        </li>
        <li class="menu-title" v-if="showHandle && studentList.length != 0 ">
          <a :class="[activeMenu == 'studentDetail' ? 'active' : '']" @click="gotoStudentDetail">{{isAgent ? `${$t('layout.Navbar.494044-2')}` : `${$t('layout.Navbar.494044-3')}`}}</a>
        </li>
      </ul>
    </div>
    <div class="navbar-right">
      <div class="search-student" v-if="showHandle && studentList.length != 0">
        <el-autocomplete
          class="search-student-popper"
          value-key="real_sname"
          v-model="state1"
          :fetch-suggestions="querySearch"
          :placeholder="isAgent ? `${$t('layout.Navbar.494044-4')}` : `${$t('layout.Navbar.494044-5')}`"
          suffix-icon="el-icon-search"
          @select="handleSearchStudent"
        ></el-autocomplete>
        <!-- <div class="not-find-student" v-if="showNotFindStudent">
          <p class="not-find-tips-1">未找到相关学生</p>
          <p class="not-find-tips-2" v-if="user_type == 4">找不到学生，可以将学生手动添加到监课</p>
          <a class="add-soon" v-if="user_type == 4" @click="addSoonStudent">立即添加</a>
        </div> -->
      </div>
      <ul class="navbar-infos clearfix" v-if="showHandle">
        <!-- <li v-if="user_type == 4">
          <a class="info-handle" slot="reference" @click="addStudent">
            <i class="icon-add-student"></i>
            {{isAgent ? '订阅用户' : $t('layout.Navbar.494044-9')}}
          </a>
        </li> -->
        <li v-if="language == 'zh' && appName !== 'qimeng'" class="jinbi-arae">
          <el-dropdown  trigger="click" @command="handleCommandSelest">
           <div class="gold-coin">
            <img class="pic" src="../../assets/images/jinbi.png" alt="">
            <div class="num"> {{ totalGoldCoin || 0}} </div>
            <div class="button-run">＋</div>
           </div>
            <el-dropdown-menu class="ul-select-list" slot="dropdown">
              <el-dropdown-item v-for="(item, index) in navList" :key="index"  :command="{ index: index,  row: item }" class="item-selest"
               :class="isSignIn == 1 && index === 0 ? 'sign-in-active' : ''" >{{ isSignIn == 1 && index === 0 ? $t('layout.Navbar.494044-6') : item }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>
        <li>
          <!-- <a v-if="!isAgent" class="info-handle" @click="dataExplain">
            <i class="icon-data-descripe"></i>
            {{ $t('layout.Navbar.494044-7') }}
          </a> -->
        </li>
        <!-- <li>
          <a class="info-handle" @click="backOld">
            <i class="el-icon-arrow-left"></i>
            切回旧版
          </a>
        </li> -->
        <li>
          <a class="info-handle">
            <i class="icon-user-avater"></i>
            <span class="user-nickname" v-if="teacherInfo.user_type == 4 ">{{teacherInfo.real_name || teacherInfo.teacher_name || teacher_id || teacherInfo.refer_teacher.real_name }}</span>
            <span class="user-nickname" v-else>
              <span v-if="teacherInfo.refer_teacher && teacherInfo.refer_teacher.real_name">{{teacherInfo.refer_teacher.real_name}}</span>
            </span>
          </a>
        </li>
      </ul>
    </div>

    <el-popover
      popper-class="add-stuent-popper"
      placement="bottom"
      width="470"
      trigger="manual"
      v-model="visible">
      <div class="add-student-modal">
        <div class="add-student-header">
          <span class="title-1">{{isAgent ? `${$t('layout.Navbar.494044-8')}` : `${$t('layout.Navbar.494044-9')}`}}</span>
          <i class="el-icon-close" @click="hidePopper"></i>
        </div>
        <el-form ref="form" :model="form" label-width="60px">
          <el-form-item :label="isAgent ? $t('layout.Navbar.494044-10') : $t('layout.Navbar.494044-11')">
            <el-autocomplete
              class="inline-input"
              clearable
              v-model="searchStudentValue"
              :fetch-suggestions="querySearchStudent"
              :placeholder="isAgent ? $t('layout.Navbar.494044-12') : $t('layout.Navbar.494044-13')"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item :label="$t('layout.Navbar.494044-14')">
            <el-select  :placeholder="$t('layout.Navbar.494044-15')" v-model="selectCourseValue" clearable @change="changeCourse">
              <el-option
                v-for="(item, index) in courseList"
                :label="item.course_name"
                :value="`${item.course_id}_${index}`"
                :key="index">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="!isNotAuth && !isNotService" class="form-btns">
            <a :class="[connectBtn.disabled ? 'add-stuent-btn confirm disable' : 'add-stuent-btn confirm']" disabled="connectBtn.disabled" @click="submitForm('ruleForm')">{{ $t('layout.Navbar.494044-16') }}</a>
            <a class="add-stuent-btn normal" @click="hidePopper">{{ $t('layout.Navbar.494044-17') }}</a>
          </div>
        </el-form>
        <div class="add-result" v-if="studentStatus != ''">
          <div>
            <span>{{isAgent ? $t('layout.Navbar.494044-10') : $t('layout.Navbar.494044-11')}}</span>
            <span>{{selectStudent.real_name}}</span>
            <span v-if="studentStatus != 3">{{ $t('layout.Navbar.494044-18') }}</span>
            <span v-else>{{ $t('layout.Navbar.494044-19') }}</span>
          </div>
          <div v-if="studentStatus == 1" class="student-status">
            <p>{{ $t('layout.Navbar.494044-20') }}</p>
            <template v-if="isAgent && isAuth == 0">
              <p>{{ $t('layout.Navbar.494044-21') }}</p>
            </template>
          </div>
          <div v-else-if="studentStatus == 2" class="student-status">
            <template v-if="!isAgent">
              <p>{{ $t('layout.Navbar.494044-22') }}</p>
              <p>{{ $t('layout.Navbar.494044-23') }}</p>
            </template>
            <template v-else>
              <p>{{ $t('layout.Navbar.494044-24') }}</p>
            </template>
          </div>
          <div v-else-if="studentStatus == 3" class="student-status">
            <template v-if="!isAgent">
              <p>{{ $t('layout.Navbar.494044-25') }}</p>
              <p>{{ $t('layout.Navbar.494044-26') }}</p>
            </template>
            <template v-else>
              <p>{{ $t('layout.Navbar.494044-27') }}</p>
            </template>
          </div>
          <div v-else-if="studentStatus == 4" class="student-status">
            <p>{{ $t('layout.Navbar.494044-21') }}</p>
          </div>
          <div class="form-btns">
            <template v-if="!isAgent">
              <a class="add-stuent-btn confirm" @click="addSuperviseClass" v-if="studentStatus == 1">{{ $t('layout.Navbar.494044-16') }}，加入监课</a>
              <a class="add-stuent-btn confirm" @click="addSuperviseClass" v-else-if="studentStatus == 2">{{ $t('layout.Navbar.494044-29') }}</a>
              <a class="add-stuent-btn confirm" @click="hidePopper" v-else-if="studentStatus == 3">{{ $t('layout.Navbar.494044-30') }}</a>
            </template>
            <template v-else>
              <a class="add-stuent-btn confirm" @click="addSuperviseClass" v-if="studentStatus == 1 && isAuth == 1">{{ $t('layout.Navbar.494044-16') }}，加入监课</a>
              <a class="add-stuent-btn confirm" @click="hidePopper" v-else>{{ $t('layout.Navbar.494044-30') }}</a>
            </template>
            <a class="add-stuent-btn normal" @click="hidePopper">{{ $t('layout.Navbar.494044-17') }}</a>
          </div>
        </div>
        <div class="add-result" v-if="isNotService">
          <p class="not-member">{{ $t('layout.Navbar.494044-24') }}</p>
        </div>
        <div class="add-result" v-if="isNotAuth">
          <p class="not-member">{{ $t('layout.Navbar.494044-31') }}</p>
        </div>
      </div>
    </el-popover>
    <!--搜索不到的浮层-->
    <div class="add-soon-mask" v-if="showNotFindStudent" @click="hideNotFindMask"></div>
    <!--/.搜索不到的浮层-->
    <el-dialog
      :title="titleTips"
      :visible.sync="isAssignedAccount"
      :close-on-click-modal="false"
      :modal-append-to-body="false"

      width="480px">
      <div class="tips-box">
        <template v-if="isShowOpen == 1">
          <div class="subtitle">{{ $t('layout.Navbar.494044-32') }}</div>
          <div class="content">
            <div class="code"><img class="pic" :src="analystImage" alt=""></div>
            <div class="right">
              <div class="text">{{ $t('layout.Navbar.494044-33') }}</div>
              <el-button type="primary" class="send-btn" @click="handlePushMessage">{{ $t('layout.Navbar.494044-34') }}</el-button>
            </div>
          </div>
      </template>
      <template v-else>
          <div class="subtitle">{{ $t('layout.Navbar.494044-35') }}</div>
          <div class="content">
            <div class="code buy"><img class="pic" :src="purchaseImage" alt=""></div>
          </div>
      </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import Bus from '@/utils/bus.js'
import i18n from '@/i18n'
import { searchInviteUserList, getUserCourseList, checkStudentOnline, sendAssignApplyNotice, getSignStatusForSupervisor,supervisorSign, getSupervisorCoins, buyCoinQrCode, agentAssignQrCode  } from '@/api/base';
import { getRealCourseValue, getIndex, getQueryString } from '@/utils'
export default {
  name: "Navbar",
  data() {
    return {
      navList: [this.$t('layout.Navbar.494044-36'), this.$t('layout.Navbar.494044-37'), this.$t('layout.Navbar.494044-38')],
      pullDownIndex: 0,
      isShowOpen: 2,
      analystImage: '', // 分析员二维码
      purchaseImage: '', // 购买二维码
      titleTips: this.$t('layout.Navbar.494044-37'),
      isSignIn: 0,
      isAssignedAccount: false,
      teacher_id: '',
      teacher_name: '',
      teacherInfo: {},
      isShowBack: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      is_member: '',
      studentStatus: 0, // 选择加入学生的状态
      searchStudentValue: '',
      selectCourseValue: '',
      courseList: [], // 课程
      selectStudent: '', // 选中的学生
      visible: false, // 是否显示添加学生的弹框
      connectBtn: {
        type: 'info',
        disabled: true
      },
      showHandle: true, // 是否显示头部的学生详情、搜索学生、添加学生、数据说明
      stuInput: '',
      selectStuList: [],
      studentList: [],
      state1: '',
      activeMenu: 'studentList',
      showNotFindStudent: false, // 模糊搜索不到结果时，是否展示结果弹框
      user_type: 4,
      currentPagePath: '',
      isAgent: false, // 是否是代理商
      isAuth: -1,
      isNotService: false,
      isNotAuth: false,
      language: '',
      appName: '',
    };
  },
  computed:{
    ...mapGetters(['studentListCardData', 'isCloseLeft']),
    totalGoldCoin(){
      return this.$store.state.user.totalGoldCoin
    }
  },
  created(){
    this.subjectId = sessionStorage.getItem('subject_id')
    this.getGoldCoin()
    this.getSignInStatus()
    i18n.locale = sessionStorage.getItem('Select-language') || 'zh'
    this.language = sessionStorage.getItem('Select-language') || 'zh'
    this.appName = getQueryString('app_name') || sessionStorage.getItem('supervise_app_name') || ''
  },
  mounted() {
    let currentPage = this.$route.path;
    let receive = this.$route.params.receive
    let host = window.location.href
    console.log('----',this.$route)
    console.log('----host',host)
    this.currentPagePath = this.$route.path;
    if (currentPage == '' || currentPage == '/') {
      this.isShowBack = false;
      this.showHandle = true;
      this.activeMenu = 'studentList';
    } else if (currentPage == '/supervise/detail') {
      this.showHandle = true;
      this.isShowBack = true;
      this.activeMenu = 'studentDetail';
    } else if (currentPage == '/supervise/wrong') {
      this.showHandle = false;
      this.isShowBack = true;
    } else if (currentPage == '/supervise/videoHandout' || currentPage == '/supervise/viewVideo') {
      this.showHandle = false;
      this.isShowBack = false;
    }
    if(receive){
      console.log('----')
      this.gotoStudentDetail()
    }
    const vm = this
    Bus.$on('msg', (e) => {
      console.log(this.$t('layout.Navbar.494044-39'), e)
      vm.studentList = e
    })
    this.teacherInfo = JSON.parse(sessionStorage.getItem('TEACHER_INFO'));
    this.user_type = sessionStorage.getItem('user_type');
    if (this.teacherInfo && this.teacherInfo.is_agent_school) {
      this.isAgent = this.teacherInfo.is_agent_school;
    }

  },
  methods: {
    // 获取金币数
    getGoldCoin(){
      let params = {
        subject_id: this.subjectId
      }
      getSupervisorCoins(params).then(res=>{
        let goldCoins = res.data.coin_cnt || 0
         if(res.code === 200){
          // this.totalGoldCoin =  goldCoins
          this.$store.commit('TOTAL_GOLD_COIN', goldCoins);
          // sessionStorage.setItem('totalGoldCoin', goldCoins)
         }
      })
    },
     // 查询签到状态
     getSignInStatus(){
      let params = {
        subject_id: this.subjectId
      }
      getSignStatusForSupervisor(params).then(res=>{
        if(res.code === 200){
          this.isSignIn = res.data.sign_status || 0
        }
      })
    },
     // 推送公众号消息
     handlePushMessage(){
      let params = {
        subject_id: this.subjectId
      }
      sendAssignApplyNotice(params).then(res=>{
        if(res.code === 200){
          this.$message.success(this.$t('layout.Navbar.494044-40'))
        }else{
          this.$message.warning(res.msg || this.$t('layout.Navbar.494044-41'))
        }
      })
    },
    handleClickToSignIn(){
      let params = {
        subject_id: this.subjectId
      }
      supervisorSign(params).then(res=>{
        if(res.code === 200){
          this.$message.success(this.$t('layout.Navbar.494044-42'));
          this.getSignInStatus()
        }
      })
    },
    // 查询学生的课程信息
    queryStudentCourseList() {
      let params = {
        account_id: this.selectStudent.account_id,
        data_source: this.selectStudent.data_source,
        subject_id: sessionStorage.getItem('subject_id')
      }
      getUserCourseList(params).then(res => {
        if (res.code == 200) {
          if (res.data.list) {
            this.courseList = res.data.list;
          }
        }
      })
    },
    handleCommandSelest(item){
      console.log('--',item)
      let params = {
        subject_id: this.subjectId
      }
      if(item.index === 0){
        if(this.isSignIn == 1){
          this.$message.warning(this.$t('layout.Navbar.494044-43'));
          return
        }
        this.handleClickToSignIn()
      }else if(item.index === 1){
        this.isAssignedAccount = true
        this.isShowOpen = 1
        this.titleTips = this.$t('layout.Navbar.494044-37')
         // 分析员分配二维码
      agentAssignQrCode(params).then(res=>{
        if(res.code === 200){
          this.analystImage = res.data.qrcode_url || ''
          console.log(res)
        }
      })
      }else if(item.index === 2){
        this.isAssignedAccount = true
        this.isShowOpen = 2
        this.titleTips = this.$t('layout.Navbar.494044-44')
        // 到小程序购买二维码
        buyCoinQrCode(params).then(res=>{
        if(res.code === 200){
          this.purchaseImage = res.data.qrcode_url || ''
          console.log(res)
        }
      })
      }
    },
    // 获取当前校区下的学生
    async querySearchStudent(queryString, cb) {
      let schoold_id = sessionStorage.getItem('school_id');
      let subject_id = sessionStorage.getItem('subject_id');
      let list = await this.getCurrentSchoolStudent(queryString, schoold_id, subject_id);
      if (list.length > 0) {
        let result = list.map(item => {
          return {
            value: `${item['real_name']}（${item['uname']}）`,
            account_id: item['account_id'],
            data_source: item['data_source'],
            real_name: item['real_name'],
            is_auth: this.isAgent ? item['is_auth'] : 1
          }
        })
        cb(result);
      } else {
        if (this.isAgent) {
          this.isNotService = true;
          this.isNotAuth = false;
          cb([])
        }
      }
    },
    getCurrentSchoolStudent(keyword, school_id, subject_id) {
      if (keyword.trim() == '') {
        return [];
      }
      return new Promise(function(resolve, reject) {
        const data = {
          school_id: school_id,
          keyword: keyword,
          subject_id: subject_id
        }
        searchInviteUserList(data).then(res => {
          if (res.code == 200) {
            const data = res.data
            resolve(data.items)
          }
        })
      })
    },
    gotoIndex () {
      this.$router.push({ path: '/supervise/', query: {} });
    },
    // 学生详情
    gotoStudentDetail () {
      if (this.studentList.length > 0) {
        // let item = this.studentList[0];
        // Bus.$emit('navBarViewStudent', item, 0);
        let currentPage = this.$route.path;
        if (currentPage == '' || currentPage == '/') {
          Bus.$emit('viewFirstStudent');
        } else {
          Bus.$emit('viewFirstStudent', 'left');
        }
      }
    },
    getPath () {
      let currentPage = this.$route.path;
      this.currentPagePath = this.$route.path;
      if (currentPage == '' || currentPage == '/') {
        this.isShowBack = false;
        this.showHandle = true;
        this.activeMenu = 'studentList';
      } else if (currentPage == '/supervise/detail') {
        this.showHandle = true;
        this.isShowBack = true;
        this.activeMenu = 'studentDetail';
      } else if (currentPage == '/supervise/wrong' || currentPage == '/supervise/videoHandout' || currentPage == '/supervise/viewVideo') {
        this.showHandle = false;
        this.isShowBack = true;
      }
    },
    // 添加学生，显示弹框
    addStudent () {
      this.visible = true;
    },
    // 隐藏添加监课学生的弹框
    hidePopper () {
      this.visible = false;
      this.studentStatus = '';
      this.searchStudentValue = '';
      this.selectCourseValue ='';
      this.isAuth = -1;
      this.isNotService = false;
    },
    handleSelect(item) {
      if (this.isAgent && item.is_auth == 0 ) {
        this.isNotAuth = true;
      } else {
        this.isNotAuth = false;
      }
      this.selectStudent = item;
      this.queryStudentCourseList();
    },
    // 切换课程
    changeCourse () {
      this.courseList.map((item, index) => {
        let courseId = getRealCourseValue(this.selectCourseValue)
        let courseIndex = getIndex(this.selectCourseValue)
        if (item.course_id == courseId && index == courseIndex) {
          this.selectedUserId = item.user_id;
          this.selectedTeacherId = item.teacher_id;
        }
      })
    },
    submitForm () {
      let params = {
        user_id: this.selectedUserId,
        teacher_id: sessionStorage.getItem('teacher_id'),
        subject_id: sessionStorage.getItem('subject_id'),
      }
      checkStudentOnline(params).then(res => {
        if (res.code == 200) {
          let is_online = res.data.is_online
          this.is_member = res.data.is_member
          if (res.data.is_auth) {
            this.isAuth = res.data.is_auth
            this.studentStatus = 4;
          }
          if (is_online == 1) { // 学生在线，判断当前学生是否属于这个分析员
            let currentTeacherId = sessionStorage.getItem('teacher_id')
            let isBelong = false;
            this.selectedTeacherId.map(item => {
              if (item == currentTeacherId) {
                isBelong = true;
              }
            })
            if (isBelong) { // 当前学生在线，并且是属于这个分析员
              this.studentStatus = 1;
            } else { // 当前学生在线，但属不于这个分析员
              this.studentStatus = 2;
            }
          } else { // 学生不在线
            this.studentStatus = 3;
          }
        }
      })
    },
     // 最终加入到监课
    addSuperviseClass() {
      this.visible = false;
      this.studentStatus = '';
      this.searchStudentValue = '';
      this.selectCourseValue ='';

      if (this.is_member ==  1) { // 当前学生已经在监课分析员的列表下，弹出提示
        this.$message({
          type: 'success',
          message: this.$t('layout.Navbar.494044-45')
        })
      } else if (this.is_member ==  0) { // 当前学生不在分析员的监课范围内
        let teacherInfo = JSON.parse(sessionStorage.getItem('TEACHER_INFO'))
        let real_name = '';
        if (teacherInfo.refer_teacher) {
          real_name = teacherInfo.refer_teacher.real_name;
        }
        //  邀请新学生上线
        const INVITE_STUDENT = {
          'event': 'INVITE_STUDENT',
          "role": "TEACHER",
          'teacher_id': sessionStorage.getItem('teacher_id'),
          'subject_id': sessionStorage.getItem('subject_id'),
          'school_id': sessionStorage.getItem('school_id'),
          'nick': real_name,
          'app_type': this.selectStudent.data_source,
          'user_id': this.selectedUserId,
        }
        window.$_chat.sendMessage(INVITE_STUDENT)
      }
    },
    querySearch (queryString, cb) {
      var results = queryString ? this.studentList.filter(this.createFilter(queryString)) : this.studentList;
      // 调用 callback 返回建议列表的数据
      if (queryString != '' && results == '') {
        this.showNotFindStudent = true;
      } else {
        this.showNotFindStudent = false;
      }
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.real_sname.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
    handleSearchStudent (item) {
      let index = '';
      for (let i=0; i < this.studentList.length; i++) {
        let student = this.studentList[i];
        if (item['user_id'] == student['user_id']) {
          index = i;
          break;
        }
      }
      this.$store.commit('SET_CURRENT_USER_ID', item['user_id']);
      Bus.$emit('navBarViewStudent', item, index);
    },
    // 数据说明
    dataExplain () {
      window.open('https://help.songshuai.com/?/article/542', "_blank");
    },
    // 切回旧版
    backOld () {
      if (!!sessionStorage.getItem('token')) {
        let token = sessionStorage.getItem('token');
        let href = window.location.href;
        if (href.indexOf('test') > -1) { // 测试环境
          window.location.href = 'http://test-supervise.classba.cn/?token='+token
        } else {
          window.location.href = 'http://supervise.classba.cn/?token='+token
        }
      }
    },
    // 隐藏掉弹框
    hideNotFindMask() {
      this.showNotFindStudent = false;
    },
    // 立即添加学生
    addSoonStudent () {
      this.visible = true;
      this.showNotFindStudent = false;
    },
    closeLeft() {
      this.$store.commit("SET_IS_CLOSE_LEFT", !this.isCloseLeft);
    }
  },
  watch: {
    '$route':'getPath',
    searchStudentValue(newValue, oldValue) {
      if (newValue == '') {
        this.connectBtn.type = 'info'
        this.connectBtn.disabled = true
        this.courseList = []
        this.selectCourseValue = ''
        this.studentStatus = '';
        this.isNotService = false;
        this.isNotAuth = false;
      } else {
        if (this.selectCourseValue != '' && newValue !='') {
          this.connectBtn.type = 'primary'
          this.connectBtn.disabled = false
        }
      }
    },
    selectCourseValue(newValue, oldValue) {
      if (newValue == '') {
        this.connectBtn.type = 'info'
        this.connectBtn.disabled = true
        this.studentStatus = '';
      } else  {
        if (this.searchStudentValue != '' && newValue !='') {
          this.connectBtn.type = 'primary'
          this.connectBtn.disabled = false
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/assets/theme-chalk/common/var";
@import "~@/assets/scss/var";
@import "~@/assets/scss/mixins";
.el-dropdown-link {
  display: inline-block;
  padding: 4px 0;
  line-height: 1;
  margin: 0 16px;
  font-size: 16px;
  color: $--color-white;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.el-icon-arrow-down {
  font-size: 14px;
}
.navbar {
  @include flex(1);
  height: 48px;
  .navbar-left {
    float: left;
    @include flexbox();
    .sidebar-trigger {
      display: block;
      width: 1px;
      height: 48px;
      text-align: center;
      > i {
        display: block;
        padding: 20px 0;
        font-size: 24px;
        line-height: 1;
        color: #ffffff;
        &:hover {
          color: $--color-white-light;
        }
      }
    }
    .navbar-menu {
      @include flexbox();
      @include box-vertical-center();
      margin-left: 26px;
      > li {
        height: 100%;
        &.menu-title {
          position: relative;
          margin-right: 28px;
          font-size: 16px;
          > a {
            position: relative;
            height: 100%;
            color: #FFFFFF;
            padding: 0 1px;
            @include flexbox();
            @include box-vertical-center();
            &:after {
              position: absolute;
              width: 100%;
              height: 2px;
              left: 0;
              bottom: 2px;
              background-color: #ffffff;
              content: '';
              display: none;

            }
            &:hover {
              cursor: pointer;
              &:after {
                display: block;
              }
            }
            &.active {
              &:after {
                display: block;
              }
            }
          }
          > h2 {
            padding-right: 41px;
            line-height: 24px;
            color: $--color-white;
            font-size: 16px;
            font-weight: normal;
            display: inline-block;
          }
          .icon_internal_testing {
            position: absolute;
            right: 12px;
            top: -11px;
          }
          .back-index {
            width: 124px;
            height: 28px;
            background: #5399FF;
            border-radius: 14px;
            font-size: 14px;
            color: #FFFFFF;
            display: inline-block;
            text-align: center;
            line-height: 29px;
            cursor: pointer;
            &:hover {
              opacity: 0.8;
            }
          }
        }
      }
    }
    .close-left {
      width: 24px;
      height: 48px;
      margin-left: 20px;
      color: #ffffff;
      display: flex;
      align-items: center;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .navbar-right {
    height: 100%;
    float: right;
    @include flexbox();
    @include box-vertical-center();
    .search-student {
      position: relative;
      width:280px;
      height:28px;
      margin-right: 10px;
      border-radius:500px;
      > input {
        width: 100%;
        height: 100%;
        border-radius:500px;
        border: none;
        text-indent: 16px;
      }
      .not-find-student {
        position: absolute;
        width:300px;
        height:174px;
        left: 50%;
        bottom: -186px;
        margin-left: -150px;
        background:rgba(255,255,255,1);
        box-shadow:0px 3px 10px 0px rgba(68,75,101,0.06);
        border-radius:8px;
        z-index: 10;
        .not-find-tips-1 {
          height: 22px;
          margin: 35px 0 12px 0;
          font-size: 16px;
          font-weight: 500;
          color:rgba(68,75,101,1);
          text-align: center;
        }
        .not-find-tips-2 {
          height:20px;
          margin-bottom: 20px;
          font-size:14px;
          font-weight:400;
          color:rgba(133,138,155,1);
          text-align: center;
        }
        .add-soon {
          width:88px;
          height:28px;
          border-radius:500px;
          border:1px solid rgba(41,128,255,1);
          font-size:14px;
          font-weight:400;
          color:rgba(41,128,255,1);
          display: block;
          text-align: center;
          margin: 0 auto;
          line-height: 28px;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
    .navbar-infos {
      @include flexbox();
      @include box-vertical-center();
      > li {
        // float: left;
        margin-right: 30px;
        .info-handle {
          @include flexbox();
          @include box-vertical-center();
          font-weight: 400;
          color:rgba(255,255,255,1);
          font-size:14px;
          &:hover {
            cursor: pointer;
          }
        }
        .msg-trigger {
          display: block;
          position: relative;
          margin-top: 16px;
          height: 32px;
          text-align: center;
          margin-right: 16px;
          padding-left: 40px;
          padding-right: 16px;
          border-radius: 16px;
          background: #659af9;
          &:hover {
            > span {
              font-weight: bold;
            }
          }
          > i {
            display: block;
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            padding: 20px 0;
            font-size: 14px;
            line-height: 1;
            color: #ffffff;
          }
          > span {
            display: inline-block;
            line-height: 32px;
            color: $--color-white;
          }
        }
        &.navbar-user {
          display: block;
          @include flexbox();
          @include box-vertical-center();
          height: 64px;
          position: relative;
          .el-dropdown {
            height:100%;
          }
          .user-avatar {
            position: absolute;
            left:10px;
            display: block;
            width: 32px;
            height: 32px;
            line-height: 32px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            text-align: center;
            overflow: hidden;
            > i {
              color: #ffffff;
              width: 20px;
              height: 20px;
              margin: 6px;
            }
            .avatar-image {
              width: 100%;
              height: 100%;
            }
          }
          img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
            vertical-align: middle;
          }
        }
        .user-nickname {
          width: 100px;
          height:50px;
          display: inline-block;
          padding: 7px 8px 7px 5px;
          margin-right: 24px;
          line-height: 50px;
          font-size: 14px;
          color: #ffffff;
          cursor: default;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      .jinbi-arae{
        display: flex;
        align-items: center;
        justify-content: center;
        .gold-coin{
          display: flex;
        align-items: center;
        justify-content: center;
        .pic{
          display: block;
          width: 32px;
          height: 32px;
        }
          .num{
            font-size: 14px;
            color: white;
            padding-left: 8px;
            padding-right: 9px;
          }
        .button-run{
          width: 16px;
          height: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          border: 1px solid white;
          color: white;
          border-radius: 50%;
        }
        }
      }
    }
  }
}
.change-result-wrap {
  .change-result-content {
    margin:0 auto;
    font-size:14px;
    color:rgba(68,75,101,1);
    line-height:28px;
    text-align: center;
    .icon_homework_fail,.icon_homework_success{
      margin:0 auto 24px;
    }
    .result-text {
      height: 22px;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      margin-bottom: 62px;
      &.success {
        color: rgba(70,201,53,1);
      }
      &.fail {
        color: rgba(255,71,87,1);
      }
    }
  }
}
.add-student-modal {
  .add-student-header {
    height:72px;
    padding: 0 29px 0 39px;
    @include flexbox();
    @include box-vertical-center();
    @include justify-content(space-between);
    background:rgba(255,255,255,1);
    box-shadow:0px 3px 10px 0px rgba(68,75,101,0.06);
    border-radius:8px 8px 0px 0px;
    .title-1 {
      font-size:18px;
      font-weight:500;
      color:rgba(68,75,101,1);
    }
    .el-icon-close {
      font-size: 20px;
      color: #a7b2d2;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .el-form {
    width: 360px;
    margin: 0 auto;
    margin-top: 41px;
    .el-form-item__label {
      font-size:16px;
      font-weight:400;
      color:rgba(68,75,101,1);
    }

  }
  .form-btns {
      @include flexbox();
      @include box-vertical-center();
      @include justify-content(center);
      margin-top: 50px;
      margin-bottom: 24px;
      .add-stuent-btn {
        @include flexbox();
        @include box-vertical-center();
        @include box-horizontal-center();
        width:140px;
        height:38px;
        border-radius:70px;
        font-size:14px;
        font-weight:400;
        &:first-child {
          margin-right: 10px;
        }
        &:last-child {
          margin-left: 10px;
        }
        &.normal {
          border:1px solid rgba(41,128,255,1);
          color:rgba(41,128,255,1);
          &:hover {
            cursor: pointer;
          }
        }
        &.confirm {
          background-color: rgba(41,128,255,1);
          color: #ffffff;
          &:hover {
            cursor: pointer;
          }
        }
        &.disable {
          color:rgba(167,178,210,1);
          background:rgba(243,246,249,1);
          &:hover {
            cursor: not-allow;
          }
        }

      }
    }
  .add-result {
    width: 360px;
    margin: 0 auto;
    padding-top: 24px;
    border-top: 1px solid #ededed;
    .not-member {
      padding-bottom: 10px;
    }
  }
  .student-status {
    margin-bottom: 15px;
  }
}
.add-soon-mask {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 64px;
  background-color: rgba(0,0,0,0.25);
  z-index: 1;
}
// 新增修改下拉选择
.ul-select-list{
  width: 160px;
  padding: 0 20px;
  .item-selest{
    border: 1px solid #2980FF;
    color: #2980FF;
    border-radius: 8px;
    margin: 16px 0;
    text-align: center;
    box-sizing: border-box;
  }
  .el-dropdown-menu__item:not(.is-disabled):hover{
    background: #007FFF;
    color: #ffffff;
    border-radius: 8px;
    box-sizing: border-box;
  }
    .el-dropdown-menu__item.sign-in-active{
      border: 2px solid #D3D8E8;
      border-radius: 8px;
      color: #D3D8E8;
      box-sizing: border-box;
    }
}
.tips-box{
  .subtitle{
    padding-bottom: 20px;
  }
  .content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    .code{
      width: 150px;
      height: 150px;
      // border: 2px solid whitesmoke;
      flex-shrink: 0;
      &.buy{
        margin: 0 auto;
      }
      img{
        display: block;
        width: 100%;
        height: 100%;
      }
  }
  .right{
      padding-left: 20px;
      // text-align: center;
      width: 40%;
      .text{
        padding-bottom: 20px;
        text-align: left;
      }
      .send-btn{
        border-radius: 14px;
      }
    }
  }
}
</style>
<style lang="scss">


</style>



// WEBPACK FOOTER //
// src/views/layout/Navbar.vue